import {
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Skeleton,
  Stack,
  Text,
} from '@podiumhq/design-system';
import locationPin from '../assets/locationPin.svg';
import googleLogo from '../assets/googleLogo.svg';

const ReviewInviteCard = ({ businessName }) => {
  return (
    <Box w="100%" h="100%" display="flex" flexDirection="column">
      <Box h="24px" />
      <Flex alignItems="center">
        <Image src={locationPin} w="24px" h="24px" />
        <Box ml="10px">
          <Text fontSize="lg" fontWeight="medium" color="grey.lighter">
            {businessName}
          </Text>
        </Box>
      </Flex>
      <Box h="28px" />
      <Heading fontSize="xl">We'd love for you to review our business.</Heading>
      <Box h="32px" />
      <Stack gap={3} flexGrow={1}>
        <Skeleton
          background="#EEECEA"
          isAnimated={false}
          borderRadius="8px"
          width="100%"
          height="12px"
        />
        <Skeleton
          isAnimated={false}
          background="#EEECEA"
          borderRadius="8px"
          width="100%"
          height="12px"
        />
        <Skeleton
          isAnimated={false}
          background="#EEECEA"
          borderRadius="8px"
          width="80%"
          height="12px"
        />
      </Stack>
      <Stack>
        <Button variant="primary" w="100%">
          <Image src={googleLogo} />
        </Button>
        <Button variant="outline" w="100%">
          <Skeleton
            background="#EEECEA"
            isAnimated={false}
            borderRadius="8px"
            width="50%"
            height="12px"
          />
        </Button>
      </Stack>
    </Box>
  );
};

export default ReviewInviteCard;
